import { Tooltip, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';

type Props = {
  value: number;
  isLoading?: boolean;
};

const GasUsedToTargetRatio = ({ value, isLoading }: Props) => {
  const gasTooltipBg = useColorModeValue('gray.700', 'gray.900');
  const gasTooltipColor = 'white';

  return (
    <Tooltip label="% of Gas Target" bg={ gasTooltipBg } color={ gasTooltipColor }>
      <Skeleton color="#999999" isLoaded={ !isLoading }>
        <span>{ (value > 0 ? '+' : '') + value.toLocaleString(undefined, { maximumFractionDigits: 2 }) }%</span>
      </Skeleton>
    </Tooltip>
  );
};

export default React.memo(GasUsedToTargetRatio);
